import { styled } from "@mui/material/styles";
import Popover from "@mui/material/Popover";

export const Wrap = styled("div")({
  overflowX: "auto",
  display: "flex",
  alignItems: "flex-start",

  "& .react-trello-board": {
    backgroundColor: "transparent",
    height: "calc(100vh - 235px)",
    padding: 0,
    paddingBottom: 40,

    "&::-webkit-scrollbar": {
      display: "block",
      width: 2,
      height: 8,
    },

    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },

    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#4F77DE",
      borderRight: "none",
      borderLeft: "none",
    },

    "&::-webkit-scrollbar-track-piece:end": {
      background: "transparent",
      marginBottom: 0,
    },

    "&::-webkit-scrollbar-track-piece:start": {
      background: "transparent",
      marginTop: 0,
    },
  },

  "& *": {
    marginTop: "0 !important",
  },

  "& .react-trello-lane": {
    background: "white",
    padding: "0",
    border: "0.3px solid #B9B9B9",
    borderRadius: 14,

    "& div": {
      maxHeight: "none",
      width: "100%",
    },

    "& header": {
      background: "#FCFDFD",
      borderBottom: "0.6px solid #D5D5D5",
      padding: 15,
      borderRadius: "14px 14px 0px 0px",
      display: "flex",
      fontWeight: 500,
      color: "#202224",
      justifyContent: "space-between",
      cursor: "pointer",
    },
  },

  "& .smooth-dnd-draggable-wrapper": {
    "&:last-child": {
      "& .card": {
        borderBottom: "none",
        borderRadius: "0 0 14px 14px",
      },
    },
  },
});

export const PopoverWrap = styled(Popover)({
  "& .MuiPaper-root": {
    borderRadius: "14px",
  },
  "& .MuiModal-backdrop": {
    backgroundColor: "transparent !important",
  },
});

export const Card = styled("div")({
  cursor: "pointer",
  borderBottom: "0.6px solid #D5D5D5",
  position: "relative",

  "&.rose": {
    backgroundColor: "#F0E8F5",
  },

  "&.blue": {
    backgroundColor: "#D2D9ED",
  },

  "& h3": {
    margin: 0,
    padding: "8px 15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: 300,

    "& img": {
      height: 20,
      width: 20,
      margin: "0 3px",
    },
  },
});
export const HintWrap = styled("div")({
  borderRadius: "14px",
  maxWidth: 430,
});
export const HintRow = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  gap: "0 20px",
});
export const HintItem = styled("div")({
  flex: 1,
  minWidth: "150px",
  padding: "8px 15px",

  "& .label": {
    margin: "0 0 0px",
    color: "#778097",
  },
});
export const HintHeader = styled("div")({
  borderRadius: "14px 14px 0px 0px",
  padding: 15,
  fontWeight: 600,
  fontSize: "20px",
});
export const FilterWrap = styled("div")({
  display: "flex",
  background: "#FCFCFC",
  minWidth: "100%",
  marginBottom: "10px",
});
export const FilterHeader = styled("div")({
  padding: 15,
  borderRadius: "14px 14px 0px 0px",
  display: "flex",
  fontWeight: 500,
  color: "#202224",
  justifyContent: "space-between",
});
export const FilterItem = styled("div")({});

export const FilterContent = styled("div")({
  padding: "0 10px",
  display: "flex",
  gap: "10px",
});
